import { defineFeatures } from "../define-provider-capability";

/**
 * The `intercom` features the mobile service selects. The app's bundle
 * carries these through `@libs/environment-client-contracts/mobile`, not the rest of
 * the capability, so a server-only change to it does not change the app.
 */
export const intercomMobileFeatures = defineFeatures({
  mobile: {
    scope: "runtime",
    environments: {
      local: {
        mode: "not-applicable",
        note: "Local mobile builds disable Intercom; app.config.ts gates the plugin on env presence.",
      },
      preview: {
        mode: "not-applicable",
        note: "Preview mobile builds disable Intercom.",
      },
      production: { mode: "managed" },
    },
    env: [
      {
        name: "INTERCOM_APP_ID",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "prd" },
      },
      {
        name: "INTERCOM_API_KEY_ANDROID",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "prd" },
      },
      {
        name: "INTERCOM_API_KEY_IOS",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "prd" },
      },
    ],
  },
});
